// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__1ERyQ","emails":"CreateEditClinics_emails__3ucUH","emailTagLabel":"CreateEditClinics_emailTagLabel__3eE3x"};